"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'AiAgent',
  data: function data() {
    return {
      isShowDrawer: false,
      url: ''
    };
  },
  methods: {
    showDrawer: function showDrawer() {
      this.isShowDrawer = true;
      if (this.url != '') return;
      console.log("isLoaded:", this.isLoaded, ' rul:', this.url, ' token:', cicGlobal.token, ' extNO:', cicGlobal.extNo);
      this.url = cicGlobal.aiUrl + cicGlobal.token + '&extNo=' + cicGlobal.extNo;
      console.log("isLoaded:", this.isLoaded, ' rul:', this.url, ' token:', cicGlobal.token, ' extNO:', cicGlobal.extNo);
    },
    handleClose: function handleClose() {
      this.isShowDrawer = false;
    }
  }
};
exports.default = _default;